import { useEffect, useState } from 'react';
import { supabase } from '../lib/webSite';

export const DEFAULT_WEB_STATS = [
  { value: '196', label: 'Schools' },
  { value: '60,000+', label: 'Students' },
  { value: '95%', label: 'Retention' },
  { value: '3', label: 'States' },
];

export default function useWebStats() {
  const [stats, setStats] = useState(DEFAULT_WEB_STATS);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (!supabase) return;
      try {
        const { data, error } = await supabase
          .from('web_stats')
          .select(
            'stat1_value, stat1_label, stat2_value, stat2_label, stat3_value, stat3_label, stat4_value, stat4_label',
          )
          .order('updated_at', { ascending: false })
          .limit(1)
          .maybeSingle();

        if (error) throw error;
        if (!cancelled && data) {
          setStats([
            {
              value: data.stat1_value || DEFAULT_WEB_STATS[0].value,
              label: data.stat1_label || DEFAULT_WEB_STATS[0].label,
            },
            {
              value: data.stat2_value || DEFAULT_WEB_STATS[1].value,
              label: data.stat2_label || DEFAULT_WEB_STATS[1].label,
            },
            {
              value: data.stat3_value || DEFAULT_WEB_STATS[2].value,
              label: data.stat3_label || DEFAULT_WEB_STATS[2].label,
            },
            {
              value: data.stat4_value || DEFAULT_WEB_STATS[3].value,
              label: data.stat4_label || DEFAULT_WEB_STATS[3].label,
            },
          ]);
        }
      } catch (err) {
        console.warn('Could not load web_stats; using defaults.', err);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return stats;
}
